import React, { useEffect, useState } from "react";
import { Button, Form, FormControl } from "react-bootstrap";
import { queryDemGroups } from "../logics/demandGroups";
import { Plus } from "react-bootstrap-icons";
import { DemandRate } from "../atoms/DemandRate";
import { DemandStatus } from "../atoms/DemandStatus";
import { DemandFiles } from "../molecules/DemandFiles";
import { IDem } from "../logics/types";
import { empty, validatePhoneRU } from "../../../common/functions";
import {
  IQuerySetDemRateResult,
  querySetDemRate,
} from "../logics/demandRating";
import { toast } from "react-toastify";
import "../styles/troubleshoot.css";
import { $SiteColors } from "../../../common/config/company-atts";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
import { clearNotification } from "../../../common/ui/Header/logics/notificationsLogic";

interface IShowFreeDemand {
  dem: IDem; //заявка
  setShowIdx: React.Dispatch<React.SetStateAction<number>>; //при нажатии на кнопку закрытия переводим состояние в "-1"
  companyId: number; //компания, по которому запрашиваем группы
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>; //переводим в true при успешном редактировании заявки
  showRate: boolean,
}

export const ShowFreeDemand = ({
  dem,
  companyId,
  setShowIdx,
  setSuccess,
  showRate,
}: IShowFreeDemand) => {
  //const [linput, setlinput] = useState('fdgfch')
  const [rateComment, setRateComment] = useState(""); //коммент к оценке
  const [hideRateComment, setHideRateComment] = useState(true);
  const [rate, setRate] = useState<number | null>(dem.rating); //оценка к заявке
  const [saveRateResult, setSaveRateResult] = useState<IQuerySetDemRateResult>({
    loaded: false,
    fail: false,
    msg: "",
  });

  useEffect(() => {
    queryDemGroups({ accountId: dem.accountId, companyId: companyId });
  }, []);

  // Закрытие карточки по Escape + блокировка скролла фона, пока карточка открыта.
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") { setShowIdx(-1); clearNotification(); }
    };
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    // комментарий и «Сохранить оценку» — только у выполненных (статус 5) неоценённых заявок, когда выбрана оценка
    if (showRate && Number(dem.lastStatusId) === 5 && Number(rate) > 0 && (empty(dem.rating) || Number(dem.rating) === 0)) setHideRateComment(false);
  }, [rate]);

  useEffect(() => {
    if (saveRateResult.loaded) {
      if (saveRateResult.fail) toast.error(saveRateResult.msg);
      else {
        toast.success("Данные обновлены");
        setSuccess(true);   // обновляет список заявок (DemandList)
        setShowIdx(-1);     // закрывает форму просмотра
      }
    }
  }, [saveRateResult]);

  const onSaveRateClicked = () => {
    //@ts-ignore
    querySetDemRate(dem.id, rate, rateComment, setSaveRateResult);
  };

  // неоценённая заявка приходит с rating=0 (а empty(0)===false), поэтому 0 тоже считаем «не оценено»
  let isRateEmpty = empty(dem.rating) || Number(dem.rating) === 0;
  //@ts-ignore
  let phone = empty(dem.phone) ? "" : dem.phone;
  //@ts-ignore
  let validated = validatePhoneRU(phone);
  //let textLen = empty(dem.initialText) ? 0 : dem.initialText.length
  let isAnswerEmpty = empty(dem.answer);

  return (
    <>
      <div className="omodal">
        <div
          className="omodal-content"
          style={{ background: "#F0F2F5", borderRadius: "12px" }}
          id="omodalContent"
        >
          <div
            className="row col-12 d-flex m-auto pl-0 pr-0"
            style={{ paddingBottom: "10px" }}
          >
            <div style={{ fontFamily: "SF Pro Display",color: "#22549D", fontSize: "18px", fontWeight: 700 }}>
              Заявка № {dem.id}
            </div>
            <div className="ml-auto">
              <Button onClick={() => {setShowIdx(-1); clearNotification()}} variant="default" className="bg-white rounded-circle p-0" style={{width: "30px", height: "30px%"}}>
                <Plus style={{ transform: "rotate(45deg)", width: "100%", height: "100%" }} />
              </Button>
            </div>
          </div>
          <DemandStatus
            statusName={dem.statusName}
            add2Class="div-status-in-show-dem"
            statusId={dem.lastStatusId}
          />
          <div style={{ marginBottom: "24px" }}>
          <Form.Control 
           //@ts-ignore
          value={empty(dem.groupName) ? "" : dem.groupName} readOnly={true} style={{boxShadow: "0px 0px 4px #22549D", borderRadius: "12px"}} type="text" placeholder="Категория..." title="Категория заявки" />
            {/*<LInput readonly={true} val={empty(dem.demandName) ? "" : dem.demandName} legendText={"Категория"} placeholder={"Категория"}/>*/}
          </div>
          <div style={{ marginBottom: "24px" }}>
          <Form.Control 
           //@ts-ignore
          value={validated.ok ? validated.phone : phone} readOnly={true} style={{boxShadow: "0px 0px 4px #22549D", borderRadius: "12px"}} type="text" placeholder="Телефон отсутствует" title="Телефон для связи" />
            {/*<LInput readonly={true} val={validated.ok ? validated.phone : phone} legendText={"Телефон"}  placeholder={"Телефон"} />*/}
          </div>
          <div style={{ marginBottom: "18px" }}>
          <FormControl //@ts-ignore
          value={empty(dem.initialText) ? "" : dem.initialText} style={{borderRadius: "12px", boxShadow: "0px 0px 4px #22549D", minWidth: "380px"}} placeholder={"Текст заявки отсутствует"} title="Текст заявки" as="textarea" readOnly={true} />
            {/*<LTextarea val={empty(dem.initialText) ? "" : dem.initialText} noLegend={false}legendText={"Текст"} readonly={true} placeholder="Текст заявки" />*/}
          </div>
         
          <Button
          hidden={!isAnswerEmpty}
          variant="link"
          style={{
            opacity: "50%",
            padding: "0px",
            textAlign: "left",
            textDecoration: "underline",
            boxShadow: "none",
            color: "#22549D",
            marginBottom: "20px",
          }}
          >
            {getCustomUserAgent()===getCustomUserAgentASB()?"Комментарий отсутствует":"Комментарий от УК отсутствует"}
          </Button>
          
          <div
            hidden={isAnswerEmpty}
            style={{ marginBottom: isAnswerEmpty ? "0px" : "24px" }}
          >
            <span>Комментарий от УК:</span>
            <FormControl //@ts-ignore
          value={empty(dem.answer) ? "" : dem.answer} rows={2} style={{borderRadius: "12px", boxShadow: "0px 0px 4px #22549D", resize: "both", minWidth: "380px"}} placeholder={getCustomUserAgent()===getCustomUserAgentASB()?"Комментарий отсутствует":"Комментарий от УК отсутствует"} title="Комментарий от УК" as="textarea" readOnly={true} />
            {/*<LTextarea val={empty(dem.answer) ? "" : dem.answer} legendText={"Комментарий от УК"} rows={2} readonly={true} placeholder="Комментарий от УК"/>*/}
          </div>
          {!showRate ? <></> :
            <DemandRate rate={rate} max={5} //@ts-ignore
              setRate={setRate} readonly={ Number(dem.lastStatusId) !== 5 || !isRateEmpty}
              add2class={(Number(dem.lastStatusId) !== 5 || !isRateEmpty) ? "div-dem-rate-not-clickable" : "div-dem-rate"}/>
          }
          {hideRateComment ? <></> :
            <>
              <textarea onChange={(e) => setRateComment(e.target.value)} className="p-2 form-control" placeholder="Оставьте комментарий к  оценке" rows={1} value={rateComment} style={{ borderRadius: "10px 10px 0px 10px", width: "100%", resize: "both", minWidth: "380px", maxWidth: "900px", marginBottom: "24px",}}></textarea>
              <div className="text-center" style={{ marginBottom: "24px" }}>
                <Button onClick={() => onSaveRateClicked()} variant="default" style={{ background: $SiteColors.getState().backBtnSubmit, borderRadius: "12px", color: "white", paddingLeft: "120px", paddingRight: "120px",}} >
                  Сохранить оценку
                </Button>
              </div>
            </>
          }
          <DemandFiles demid={dem.id} />
        </div>
      </div>
    </>
  );
};
